import { createIsFetchingReducer } from '../../helpers/reducers';
import { types } from '../../actions/tara';

const initialState = false;

const apiActionTypes = [
  types.TARA_POST_SURVEY,
];

const isFetching = createIsFetchingReducer(initialState, apiActionTypes);

export default isFetching;

export const getIsFetching = state => state.tara.isFetching;



// WEBPACK FOOTER //
// ./src/reducers/tara/isFetching.js